import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Avatar, Typography, Box } from "@mui/material";

import { ServiceProvider } from "../../../../api/types/topServiceProviders.types";
import { VerificationIcon } from "../../../../../../assets/icons/MUI/NetworkIcons";
import { useUserDataFormatter } from "../../../../../User/hooks/useUserDataFormatter";

const ChatHeader = ({ user }: { user: ServiceProvider }) => {
  const { t } = useTranslation("goService", {
    keyPrefix: "serviceRequestPage.chatTab",
  });

  const { fullName, firstTwoChr, countryName, isVerified, media, role, profileLink } = useUserDataFormatter(user);

  return (
    <Box sx={styles.container}>
      <Box sx={styles.topSection}>
        <Box sx={styles.avatarWrapper}>
          <Avatar src={media} sx={styles.avatar}>
            {firstTwoChr}
          </Avatar>
          {isVerified && <VerificationIcon sx={styles.verificationIcon} />}
        </Box>

        <Box sx={styles.infoWrapper}>
          <Typography sx={styles.fullName} component={Link} to={profileLink}>
            {fullName}
          </Typography>
          <Typography sx={styles.subInfo}>
            {role} {countryName && `• ${countryName}`}
          </Typography>
        </Box>
      </Box>
      <Typography sx={styles.welcomeText}>{t("welcomeText")}</Typography>
    </Box>
  );
};

export default ChatHeader;

const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
  },

  topSection: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "16px",
  },

  avatarWrapper: {
    position: "relative",
  },

  avatar: {
    width: "48px",
    height: "48px",
  },

  verificationIcon: {
    position: "absolute",
    bottom: "-4px",
    left: "50%",
    transform: "translateX(-50%)",
  },

  infoWrapper: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
  },

  fullName: {
    color: "var(--Gray-900, #101828)",
    fontSize: "18px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "28px",
    fontFamily: "Montserrat",
    textDecoration: "none",
  },
  subInfo: {
    color: "var(--Dark---1000, #111)",
    fontSize: "12px",
    fontStyle: "normal",
    fontWeight: 500,
    lineHeight: "18px",
    fontFamily: "Montserrat",
  },
  welcomeText: {
    fontFamily: "Montserrat",
    color: "var(--Dark---1000, #111)",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "20px",
  },
};
